export default {
  SM: '(max-width : 768px)',
  MD: '(min-width : 769px) and (max-width : 992px)',
  LG: '(min-width : 993px) and (max-width : 1200px)',
  XL: '(min-width : 1201px) and (max-width : 1400px)',
  XXL: '(min-width : 1401px)',
};
